
import { cn } from '@/lib/utils';

/** Avatar with image + initials fallback. */
export function Avatar({
  src,
  name,
  size = 40,
  className,
}: {
  src?: string;
  name?: string;
  size?: number;
  className?: string;
}) {
  const initials = (name || '')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase();
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-medlux-soft text-medlux-soft-foreground font-semibold',
        className,
      )}
      style={{ width: size, height: size, fontSize: Math.max(11, Math.round(size * 0.36)) }}
    >
      {src ? (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={src}
          alt={name ?? ''}
          draggable={false}
          className="h-full w-full select-none object-cover"
        />
      ) : (
        initials || '?'
      )}
    </span>
  );
}
